import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import Lottie from 'react-lottie';
import '@fontsource-variable/noto-sans-kr';
import { createGlobalStyle } from 'styled-components';
import { Frame, Main } from '@/css/style';
import useShowStore from '@/stores/common/show';
import Aside from '@/components/Aside';
import BottomNavBar from '@/components/BottomNavBar';
import PcOnly from '@/components/PcOnly';
import TopNavBar from '@/components/TopNavBar';
import animationData from '@/assets/lottieLoader.json';
import useUserStore from '../../stores/user/user';
import AsideForNotUser from '../../components/AsideForNotUser';
import useMovePath from '../../hooks/useMovePath';
import { useNavermaps } from 'react-naver-maps';

export default function Layout() {
    const script = document.createElement('script');
    script.src =
        'https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=t2kntuhk0e&submodules=geocoder';
    script.async = true;
    useEffect(() => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const ss = useShowStore();
    const { id, type } = useParams();
    const movePath = useMovePath();
    const navermaps = useNavermaps();

    useEffect(() => {
        const isLogoPath = ['/'];
        const isNotRightMenuPath = [
            '/archive',
            `/archive/${id}`,
            '/around',
            '/banner',
            '/history',
            `/history/${id}`,
            '/login',
            `/join/${type}`,
            '/map',
            '/my',
            '/my/delete',
            '/my/edit',
            '/my/likes',
            '/my/review',
            '/notice',
            `/notice/${id}`,
            '/review',
            '/term-list',
            `/styles/${id}`,
            '/faq',
            '/qna',
            `/qna/${id}`,
            '/qna/write',
            `/banner/${id}`,
            '/login/forgot',
            '/license',
            '/result',
        ];
        const isNotTopBarPath = ['/login/email', `/join/${type}`, '/around', `/reservation/${id}`];
        const isNotBottomBarPath = [
            '/archive',
            `/archive/${id}`,
            '/banner',
            '/customers',
            '/dayoffs',
            `/history/${id}`,
            `/join/${type}`,
            '/license',
            '/login',
            '/my/delete',
            '/my/edit',
            '/my/likes',
            '/my/review',
            '/notice',
            `/notice/${id}`,
            `/reservation/${id}`,
            '/rsv-designer',
            '/service-list',
            '/schedule',
            `/styles/${id}`,
            '/review',
            '/info-designer',
            '/faq',
            '/qna',
            `/qna/${id}`,
            '/qna/write',
            `/banner/${id}`,
            '/login/email',
            '/login/forgot',
            `/designer/${id}`,
            '/term-list',
            `/my/review/${id}`,
            '/map',
        ];

        const isTitlePath = [
            { path: '/map', title: '지도로 위치 찾기' },
            { path: '/history', title: '내 예약' },
            { path: '/my', title: 'MY' },
            { path: '/notice', title: '공지사항' },
            { path: '/archive', title: '아카이브' },
            { path: '/term-list', title: '약관 내용 확인' },
            { path: '/discount', title: '지금 할인중' },
        ];
        const setLogo = isLogoPath.includes(location.pathname);
        const setRightMenu = !isNotRightMenuPath.includes(location.pathname);
        const setShowTopBar = !isNotTopBarPath.includes(location.pathname);
        const setShowBottomBar = !isNotBottomBarPath.includes(location.pathname);

        for (const item of isTitlePath) {
            if (item.path === location.pathname) {
                ss.setBarTitle(item.title);
                break;
            } else if (location.pathname.includes(item.path)) {
                ss.setBarTitle(item.title);
                break;
            }
        }

        ss.setIsLogo(setLogo);
        ss.setIsRightMenu(setRightMenu);
        ss.setshowTopNavBar(setShowTopBar);
        ss.setshowBottomNavBar(setShowBottomBar);

        return () => {
            ss.terminate();
        };
    }, [location]);

    return (
        <>
            <AppStyle />
            <Frame>
                <PcOnly />
                <Main>
                    {ss.showTopNavBar && <TopNavBar />}
                    {/* {!us.user.user_id ? <AsideForNotUser /> : <Aside />} */}

                    {ss.lottie && (
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: animationData,
                            }}
                            style={lottieStyle}
                        />
                    )}
                    <Outlet context={{ navigate: movePath, navermaps }} />
                    {ss.showBottomNavBar && <BottomNavBar />}
                </Main>
            </Frame>
        </>
    );
}

const AppStyle = createGlobalStyle`
    html, body{
        height: 100%;
    }
    body{
        background-color:#f8f8f8;
    }
`;

const lottieStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '3.5rem',
    height: '3.5rem',
    transform: 'translate(-50%,-50%)',
    pointerEvents: 'none',
    zIndex: 99,
    marginLeft: '22rem',
};
